import React from 'react';


function Note() {
  return (
    <div className="note">
      <p>
        <strong>Examples for the Application Path</strong><br />
        
        <br/>
          <strong>App Path:</strong><code>C:\Program Files\ExampleApp\app.exe</code>
          <br/>
          <strong>URLs:</strong><code>https://www.example.com/app</code>
        
        </p>
    </div>
  );
}

export default Note;
